export default "__VITE_ASSET__DgTzjHAU__"